@if (loaded()) {
  <div id="hunt-details-page-wrapper">
    <div class="page-header">
      <div class="left">
        <hyperkit-breadcrumb-list
          class="breadcrumb-list"
          [items]="breadcrumbs()"
        ></hyperkit-breadcrumb-list>
        <div>
          <hyperkit-typography variant="h2" display="inline">
            {{ huntView.name() }}
          </hyperkit-typography>
          @if (huntView.totalHuntQueries() > 0) {
            <hyperkit-segmented-progress-bar
              [segments]="huntView.huntProgressSegments()"
              [showLabels]="true"
              size="small"
            ></hyperkit-segmented-progress-bar>
          }
        </div>
        <div class="meta-data-tags">
          <hyperkit-badge
            [variant]="huntView.priorityVariant()"
            size="base"
            indicator="none"
            icon="check"
            textLeft="Priority"
            [text]="huntView.priority()"
          ></hyperkit-badge>
          <hyperkit-badge
            [variant]="huntView.statusVariant()"
            size="base"
            indicator="none"
            icon="check"
            textLeft="Status"
            [text]="huntView.status()"
          ></hyperkit-badge>
          @if (huntView.outcome()) {
            <hyperkit-badge
              [variant]="huntView.outcomeVariant()"
              size="base"
              indicator="none"
              icon="check"
              textLeft="Outcome"
              [text]="huntView.outcome()"
            ></hyperkit-badge>
          }
          <hyperkit-tag
            mode="outline"
            [closable]="false"
            textLeft="Created"
            [text]="huntView.createdDate()"
          ></hyperkit-tag>
          <hyperkit-tag
            mode="outline"
            [closable]="false"
            textLeft="Last Modified"
            [text]="huntView.lastModified()"
          ></hyperkit-tag>
          <hyperkit-tag
            mode="outline"
            [closable]="false"
            textLeft="Author"
            [text]="huntView.authorFullName()"
          ></hyperkit-tag>
          <hyperkit-tag
            mode="outline"
            [closable]="false"
            textLeft="Assignee"
            [text]="huntView.assigneeFullName()"
          ></hyperkit-tag>
          @if (huntView.hasHuntTemplate()) {
            <hyperkit-tag
              [routerLink]="['/hunt/hunt-template', huntView.huntTemplateId()]"
              icon="link-2"
              mode="fill"
              [closable]="false"
              textLeft="Template"
              [text]="huntView.huntTemplateName()"
            ></hyperkit-tag>
          }
        </div>
      </div>
      <div class="right">
        @if (error) {
          <hyperkit-error [error]="error"></hyperkit-error>
        }
        @if (session.saveStatus() === 'failed') {
          <hyperkit-error
            error="Not saved: your latest changes failed to save."
          ></hyperkit-error>
        } @else if (session.saveStatus() === 'saving') {
          <hyperkit-typography variant="body" size="sm">
            Saving…
          </hyperkit-typography>
        } @else if (session.saveStatus() === 'saved') {
          <hyperkit-typography variant="body" size="sm">
            Saved
          </hyperkit-typography>
        }
        <hyperkit-button
          variant="standard"
          color="secondary"
          size="small"
          text="Continue to Reporting"
          (click)="closeHunt()"
          icon="arrow-right"
          iconPosition="right"
        ></hyperkit-button>
        <hyperkit-button-menu
          variant="icon"
          color="secondary"
          size="medium"
          icon="menu"
          (itemSelected)="handleMenuAction($event)"
        >
          <hyperkit-dropdown-menu-item
            value="update"
            label="Update Hunt Details"
          ></hyperkit-dropdown-menu-item>
          <hyperkit-dropdown-menu-item
            value="archive"
            label="Archive"
          ></hyperkit-dropdown-menu-item>
        </hyperkit-button-menu>
      </div>
    </div>
    <div class="page-content">
      <div id="hunt-packages">
        <div id="hunt-packages-header">
          <div id="hunt-package-title">
            <hyperkit-typography variant="h5">
              Packages ({{ huntView.huntPackages().length }})
            </hyperkit-typography>
          </div>
          <div id="hunt-package-list">
            @for (pkg of huntView.huntPackages(); track pkg) {
              <hunt-package-list-item
                [huntPackage]="pkg"
                (click)="navigateToHuntPackage(pkg.UUID)"
                queryParamsHandling="preserve"
              ></hunt-package-list-item>
            }
          </div>
        </div>
      </div>
      <div id="hunt-package-details">
        <hunt-details-editor
          title="Abstract"
          [value]="huntView.abstract()"
          (valueChange)="huntEditor.updateAbstract($event)"
        ></hunt-details-editor>
        <hunt-details-editor
          title="Hypothesis"
          [value]="huntView.hypothesis()"
          (valueChange)="huntEditor.updateHypothesis($event)"
        ></hunt-details-editor>
      </div>
      <div id="hunt-notes">
        <hunt-details-editor
          title="Notes"
          height="calc(100vh - 170px)"
          [value]="huntView.notes()"
          (valueChange)="huntEditor.updateNotes($event)"
        ></hunt-details-editor>
      </div>
    </div>
  </div>
} @else {
  <p>Loading…</p>
}
